// JsFromRoutes CacheKey 63ffe3ab4f593650306901b8408609c1
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  create: definePathHelper('post', '/api/v1/sign-in/create'),
  validate: definePathHelper('post', '/api/v1/sign-in/validate'),
}
